import useBoundingBoxState from "./useBoundingBoxState";
import MicroscopyRegionItemLayer from "./MicroscopyRegionItemLayer";
import SubregionOutlineWrapper from "./SubregionOutlineWrapper";
import LayoutValueImageContent from "./LayoutValueImageContent";

import { useContext, useState } from 'react';
import { useStore } from 'react-redux';
import { useEffect } from 'react';
import { NodeDisplayContext } from './Contexts';
import G from './Getters';

import NodeWrapper from './NodeWrapper';
import { layersByChannelIdToLayers } from "./utils";

export default function LayoutValueImage({
 nodeId, 
  annotationId,
  style,
  node,
  regions,
  regionId, 
  children, 
  selectedNodes, 
  onEvent, 
  nodes,
  parentPixelDimensions 
}){

  

  let nodeDisplayContext = useContext(NodeDisplayContext);
  const [ parentBox, parentBoxRef ] = useBoundingBoxState();

  let { value={} } = node || {};
  let store = useStore();
  let state = store.getState();

  const { borderColor='white', borderWidth=0, padding=0 } = style || {};

  let subregionAtns;
  if( regionId === "main" ){
    let state = store.getState();
    subregionAtns = Object.keys(regions).map(key => {
      
      if( key !== "main" ){
        let atnIdAtRegion = regions[key]
        if( !atnIdAtRegion ){ return; }
        return G.getData(state,{_id:atnIdAtRegion,type:"annotations"});
      }
    }).filter(x => x);
  }

  const resolvedOuterPadding = Math.max(0,padding - borderWidth);

  let { w, h } = parentPixelDimensions;
  let dims = {
    width:w - resolvedOuterPadding *2,
    height:h - resolvedOuterPadding *2,
  }

  let propsToDrill = {
    node,
    nodeId,
    nodes,
    regions,
    selectedNodes,
    onEvent,

  }

  let layoutValueImageContentProps = {
    value,
    node,
    annotationId,
    dims,
    padding,
    ...propsToDrill,
  }
  
  let content = (
    <LayoutValueImageContent 
    {...layoutValueImageContentProps}
    />
  );

  let inlineCrop;

  let { layersByChannelId } = node.value;

  let layers = layersByChannelIdToLayers(layersByChannelId);

  let channelHasImage = layers.some(({imageId}) => imageId);

  let nodeDisplayOverride = nodeDisplayContext?.nodeDisplay?.({node,nodeId,
    regionId,
    content,
  })
  if( nodeDisplayOverride !== undefined ){
    content = nodeDisplayOverride;
  }

  

  let willIterateChildren = (
    children && channelHasImage && parentBox
  )


  


  let subregionOutlineWrapperLayer = annotationId && (<>

    {/* this order makes sure the region stays on top */}
    <SubregionOutlineWrapper {...{
      subregionAtns, 
      inlineCrop, 
      imageSetId:G.getImageSetIdByAnnotationId(state,annotationId), 
      annotationId, 
      ...propsToDrill,
    }}/>

    {willIterateChildren && <MicroscopyRegionItemLayer {...{
      children,
      ...propsToDrill,
      parentBox,
      parentPixelDimensions,
    }}/>}


  </>)


  let decoration = nodeDisplayContext?.nodeDecoration?.({regionId,nodeId,node,content,
    caller:"LayoutValueImage"
  })

  //if( decoration ){ debugger; }

  const layerOrder = [
    content,
    decoration,
    subregionOutlineWrapperLayer
  ]

  

  return (
    <div class="image-parent" nodeId={nodeId} component={"layoutvalueimage"} 
      style={{ ...style, ...dims, }}>
      <div class="rel-cover" 
        //onMouseDown={(e) => { e.stopPropagation(); }}
      >
        <div ref={parentBoxRef} style={{ pointerEvents:'auto', }} class={`rel-cover`}>
          {layerOrder}
        </div>
      </div>
      <NodeWrapper node={node} nodeId={nodeId}/>
    </div>
  )

}
